import { render, staticRenderFns } from "./PublicBookAppointment.vue?vue&type=template&id=25ccf2b6&scoped=true&"
import script from "./PublicBookAppointment.vue?vue&type=script&lang=js&"
export * from "./PublicBookAppointment.vue?vue&type=script&lang=js&"
import style0 from "./PublicBookAppointment.vue?vue&type=style&index=0&id=25ccf2b6&scoped=true&lang=css&"
import style1 from "./PublicBookAppointment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ccf2b6",
  null
  
)

export default component.exports